import React from 'react'
import { Link } from 'react-router-dom'
import { Banknote, CheckCircle2, Coins } from 'lucide-react'
import { cn } from '../../lib/utils'

const ICONS = {
  'check-circle': CheckCircle2,
  coins: Coins,
  banknote: Banknote
}

const AccountShortcutGrid = ({ items = [], className }) => {
  if (!items.length) return null

  return (
    <div className={cn('grid w-full grid-cols-3 gap-4', className)}>
      {items.map(item => {
        const Icon = ICONS[item.icon] || CheckCircle2
        return (
          <Link
            key={item.id}
            to={item.to}
            className="flex flex-col items-center gap-2.5 text-center"
          >
            <span className="flex items-center justify-center rounded-xl bg-primary/10 p-4">
              <Icon className="size-6 text-foreground" strokeWidth={1.75} />
            </span>
            <span className="truncate text-sm font-medium text-foreground">
              {item.shortcutLabel || item.label}
            </span>
          </Link>
        )
      })}
    </div>
  )
}

export default AccountShortcutGrid
